export function splitByCharacter(string: string) {
  return string ? string.split('@').join(', ') : string;
}

export function splitByComma(string: string) {
  return string ? string.split(', ').join('@') : string;
}
